import {
  MakerIndexResponse,
  MakerWithCategoriesResponse,
} from "@/web-client/api";
import Link from "next/link";

type MakerIdentityProps = {
  maker: MakerIndexResponse | MakerWithCategoriesResponse;
  logoMaxWidth?: number;
};

const MakerIdentity = ({
  maker,
  logoMaxWidth,
}: MakerIdentityProps): JSX.Element => {
  if (!maker.logo)
    return (
      <div className="max-w-[640px] text-center mx-auto">
        <h1 className="laptop:text-3xl text-2xl w-full text-center">
          <Link href={`/makers/${maker.id}`}>{maker.name}</Link>
        </h1>
      </div>
    );

  return (
    <div
      className="flex flex-col items-center space-y-12"
      style={{ maxWidth: logoMaxWidth || "unset" }}
    >
      <h1 className="text-xs text-secondary text-center">{maker.name}</h1>
      {maker.logo && (
        <Link
          className="flex items-center justify-center"
          href={`/makers/${maker.id}`}
        >
          <img src={maker.logo.urls.original} alt={maker.name} />
        </Link>
      )}
    </div>
  );
};

export default MakerIdentity;
